export default __webpack_public_path__ + "static/media/My-referrals-Grey.96747f77.svg";